/* src/app/user-default/hr-menu/hr-menu.component.scss */
/*# sourceMappingURL=hr-menu.component-GO67F3NY.css.map */
